// extracted by mini-css-extract-plugin
export default {"steps":"InvestmentProcess_steps__eTxn9","step":"InvestmentProcess_step__w4Xp-","number":"InvestmentProcess_number__pD33w"};